import { useTranslation } from 'react-i18next'
import styles from './HelpPage.module.scss'

const ApiDocsPage = () => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('helpPage.api_title')}</h1>
      </div>
      <div className="unv-card" style={{ padding: 0, overflow: 'hidden' }}>
        <iframe
          title="API Docs"
          src="/api/docs/"
          style={{ width: '100%', height: '80vh', border: 0 }}
        />
      </div>
    </div>
  )
}

export default ApiDocsPage
